export default "__VITE_ASSET__CR5K8Tat__"